import { z } from 'zod';
import { IsoTimestamp, SchoolId } from './common.js';
/** Firestore path: schools/{schoolId}/subjects/{subjectId} */
export const SubjectStatus = z.enum(['active', 'archived', 'draft']);
/**
 * Longest Subject name the master accepts. The Quiz Editor offers these names
 * as selectable labels, so a quiz's `subject` field must allow the same length
 * or a valid master record could not be saved onto a quiz.
 */
export const SUBJECT_NAME_MAX = 200;
export const Subject = z.object({
    id: z.string().min(1).max(64),
    schoolId: SchoolId,
    name: z.string().trim().min(1).max(SUBJECT_NAME_MAX),
    code: z.string().trim().min(1).max(32),
    externalAimsisId: z.string().trim().min(1).max(128).nullable().optional(),
    status: SubjectStatus.default('active'),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
});
export const CreateSubjectRequest = z.object({
    name: z.string().trim().min(1, 'Name is required.').max(SUBJECT_NAME_MAX),
    code: z.string().trim().min(1, 'Code is required.').max(32),
    externalAimsisId: z.string().trim().min(1).max(128).nullable().optional(),
    status: SubjectStatus.optional(),
});
export const UpdateSubjectRequest = CreateSubjectRequest.partial();
//# sourceMappingURL=subject.js.map